import axios from 'axios'

const configuredBaseURL = import.meta.env.VITE_API_BASE_URL?.trim()
if (!configuredBaseURL) throw new Error('VITE_API_BASE_URL 未配置')
const baseURL = configuredBaseURL.replace(/\/+$/, '')

export const apiClient = axios.create({
  baseURL,
  timeout: 10_000,
})
